import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';
import { setBarrierDPOT, setBarrierHeight } from '@reducers/options/barrier/actions';
import { setSafetyBarrierDimensions } from '@reducers/selectors/dimension/actions';
import { CladdingTypes } from "@object-generators/safety-barrier/objects/cladding";
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { APP_TYPES } from '@config';

const SafetyBarrierDimensions = props => {
  const isCladdingDisabled = props.cladding.type === CladdingTypes.None;

  const handlePercentageChange = (value) => {
    if (!isCladdingDisabled) {
      props.setSafetyBarrierDimensions({
        ...props.safetyBarrierDimensions,
        claddingPercentage: parseFloat(value)
      });
    }
  };

 return (
   <div className="calculation">
     <section className="list-type">
       <h4>{APP_TEXTS.SAFETY_BARRIER_HEIGHT_LABEL.Content}</h4>
       <Tooltip content={APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_HEIGHT.Content}>
         <Input
           prefix="Hgc:"
           postfix={unitLabel(props.distanceUnit)}
           id="hgc"
           type="number"
           minValue={0}
           value={unitTransform(props.barrier.height).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
           onUpdate={value => {
             props.setHgc(unitTransform(value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
           }}
         />
       </Tooltip>

       <h4>{APP_TEXTS.DISTANCE_BETWEEN_POSTS_LABEL.Content}</h4>
       <Tooltip content={APP_TOOLTIPS.TOOLTIP_DISTANCE_BETWEEN_POSTS.Content}>
         <Input
           prefix="Dpot:"
           postfix={unitLabel(props.distanceUnit)}
           id="dpot"
           type="number"
           minValue={0}
           value={unitTransform(props.barrier.dpot).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
           onUpdate={value => {
             props.setDpot(unitTransform(value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
           }}
         />
       </Tooltip>
        <h4>{APP_TEXTS.CLADDING_PROPERTIES_LABEL.Content}</h4>
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_CLADDING_PROPERTIES.Content}>
          <Input
            prefix=""
            postfix="%"
            id="claddingPercentage"
            type="number"
            minValue={0}
            maxValue={100}
            disabled={isCladdingDisabled}
            value={props.safetyBarrierDimensions.claddingPercentage || 100}
            onUpdate={handlePercentageChange}
          />
        </Tooltip>
      </section>
    </div>
  );
};

const mapState = state => ({
 barrier: state.options.barrier,
 cladding: state.options.cladding,
 distanceUnit: state.main.units.distance,
  safetyBarrierDimensions: state.selectors.dimension[APP_TYPES.SAFETY_BARRIER].safetyBarrierDimensions
});

const mapDispatch = dispatch => ({
 setHgc: value => dispatch(setBarrierHeight(parseFloat(value))),
  setSafetyBarrierDimensions: options => dispatch(setSafetyBarrierDimensions(options)),
 setDpot: value => dispatch(setBarrierDPOT(parseFloat(value)))
});

export default connect(mapState, mapDispatch)(SafetyBarrierDimensions);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/SafetyBarrierDimensions/index.js